module.exports = global["MobileDetect"] = require("-!.\\mobile-detect.js");